module.exports = __webpack_public_path__ + "static/media/Portrait-10202.5c73ccc5.jpg";